export const fifthInEverySix = (index: number) => index % 6 === 4;

export const noAd = () => false;
